import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const stats = [{
    value: '52',
    label: 'Bytových jednotek'
  }, {
    value: '2',
    label: 'Podzemní patra garáží'
  }, {
    value: 'A',
    label: 'Energetická třída'
  }, {
    value: '~60%',
    label: 'Měsíční náklady vs. standard'
  }];
  return <section id="o-projektu" className="py-24 bg-base-cream" data-id="element-14" data-mp="27c5gors9mga4">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-15" data-mp="27dqd6my549am">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-16" data-mp="22lf875ojlxb7">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-17" data-mp="1xm2o2sp234cb">
            <h2 className="font-heading text-4xl md:text-5xl text-primary mb-6" data-id="element-18" data-mp="1jp74i6b6hui0">
              O projektu
            </h2>
            <div className="space-y-6 text-base-gray text-lg leading-relaxed" data-id="element-19" data-mp="xjb36b6vkvpa">
              <p className="text-[20px] font-[700]" data-id="element-20" data-mp="itwtt33aue9w">
                Moderní bydlení, které dává smysl i za mnoho let.
              </p>
              <p data-id="element-21" data-mp="nu1bgwfy1f1p">
                Dům u sv. Václava v Dolních Jirčanech spojuje špičkové
                technologie, nízké provozní náklady a zdravé prostředí pro
                každodenní život. Využívá energeticky efektivní řešení, chytré
                řízení spotřeby a promyšlené konstrukce, které reagují na
                současné i budoucí nároky na bydlení. Byty jsou navrženy s
                důrazem na funkčnost, variabilitu a přirozené propojení
                interiéru s venkovním prostorem. Součástí projektu je také
                zázemí služeb a občanské vybavenosti, které zvyšují komfort
                každodenního fungování. Výsledkem je bydlení, které není jen
                moderní dnes, ale obstojí i v budoucnu – z hlediska nákladů,
                hodnoty i kvality života.
              </p>
              <div className="pt-4" data-id="element-22" data-mp="1ssof08gu2o3r">
                <a href="#o-projektu-stranka" className="inline-block bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-23" data-mp="1o0wn9ulxycc1">
                  Více o projektu
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-24" data-mp="1a03p8zwfkz46">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-25" data-mp="32y8yk6l0jpgm">
              <img src="https://cdn.magicpatterns.com/uploads/39KQJnk7h7vyeYhmKC3uMY/1.png" alt="Pohled na projekt Svatý Václav" className="w-full h-full object-cover" data-id="element-26" data-mp="32wg37nfuornx" />
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-primary/10 rounded-full -z-10 blur-2xl" data-id="element-27" data-mp="3gom6wa1th66h"></div>
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-accent/10 rounded-full -z-10 blur-2xl" data-id="element-28" data-mp="2k0pxpq8pld5a"></div>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-primary/10 pt-16" data-id="element-29" data-mp="2t02y7teuurdv">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="text-center" data-id="element-30" data-mp="2y07fhlnl7q55" data-mpi={index}>
              <div className="font-heading text-5xl md:text-6xl text-accent mb-3" data-id="element-31" data-mp="1v73bmoxz55k3">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-base-dark font-medium uppercase tracking-wider" data-id="element-32" data-mp="1q6pei1xwvg0u">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}